// frontend/src/components/Logo.js
import React, { useState, useEffect, useRef } from 'react';

function Logo({ 
  empresaId, 
  size = 'medium', 
  showName = true,
  style = {}
}) {
  const [logoUrl, setLogoUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erroCarregar, setErroCarregar] = useState(false);
  const carregouRef = useRef(false); // Para evitar carregar múltiplas vezes

  // Tamanhos disponíveis
  const sizes = {
    small: { width: '30px', height: '30px', fontSize: '12px' },
    medium: { width: '50px', height: '50px', fontSize: '16px' },
    large: { width: '80px', height: '80px', fontSize: '20px' },
    header: { width: '40px', height: '40px', fontSize: '14px' },
    footer: { width: '60px', height: '60px', fontSize: '18px' }
  };

  const currentSize = sizes[size] || sizes.medium;

  // LOGO PADRÃO (USAR SEMPRE ESTE PRIMEIRO)
  const LOGO_PADRAO = '/logos/default/logo-default.png';

  useEffect(() => {
    // Se já carregou uma vez, não carrega de novo
    if (carregouRef.current) return;
    
    const loadLogo = async () => {
      try {
        // Se não tem empresaId, usa o padrão
        if (!empresaId) {
          setLogoUrl(LOGO_PADRAO);
          setLoading(false);
          carregouRef.current = true;
          return;
        }

        // Tenta buscar da API
        const token = localStorage.getItem('token');
        if (!token) {
          setLogoUrl(LOGO_PADRAO);
          setLoading(false);
          carregouRef.current = true;
          return;
        }

        const response = await fetch(`/api/empresas/${empresaId}/logo`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        if (response.ok) {
          const data = await response.json();
          if (data.logoUrl) {
            setLogoUrl(data.logoUrl);
          } else {
            setLogoUrl(LOGO_PADRAO);
          }
        } else {
          setLogoUrl(LOGO_PADRAO);
        }
      } catch (err) {
        console.warn('Erro ao carregar logo, usando padrão:', err);
        setLogoUrl(LOGO_PADRAO);
      } finally {
        setLoading(false);
        carregouRef.current = true;
      }
    };

    loadLogo();
  }, [empresaId]); // Só executa quando empresaId mudar

  // Se estiver carregando, mostra placeholder estável
  if (loading) {
    return (
      <div style={{
        width: currentSize.width,
        height: currentSize.height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style
      }}>
        <span style={{ fontSize: currentSize.fontSize }}>📊</span>
      </div>
    );
  }

  // URL final do logo
  const urlFinal = logoUrl || LOGO_PADRAO;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', ...style }}>
      <img 
        src={urlFinal}
        alt="Logo"
        style={{
          width: currentSize.width,
          height: currentSize.height,
          objectFit: 'contain',
          borderRadius: '4px',
          display: 'block'
        }}
        onError={() => {
          // Se a imagem falhar, usa o padrão (sem recarregar)
          if (urlFinal !== LOGO_PADRAO) {
            setLogoUrl(LOGO_PADRAO);
          }
        }}
      />
      {showName && (
        <span style={{ 
          fontSize: currentSize.fontSize,
          fontWeight: 'bold',
          color: 'inherit'
        }}>
          Contabilidade Online
        </span>
      )}
    </div>
  );
}

export default Logo;